/**
 * Block 12 calculator — округление вверх до ближайшего чётного числа.
 *
 * Используется per Aibek правило **OQ-5** для `facadeCount` Шкаф/Балкон
 * (любой type), `hingeCount` Шкаф/Балкон (любой type) и `golaCount` Кухня
 * (любой type). См. `docs/methodology/calculator-formulas.md` §1.2.
 *
 * **Алгоритм:** `Math.ceil(n)` → если результат нечётный, прибавить 1.
 *
 * @example
 *   ceilToEven(0)    // 0    (already even)
 *   ceilToEven(1)    // 2    (ceil=1 → +1)
 *   ceilToEven(8)    // 8    (already even)
 *   ceilToEven(8.0)  // 8    (already even)
 *   ceilToEven(8.8)  // 10   (ceil=9 → +1)
 *   ceilToEven(17.6) // 18   (ceil=18, even)
 *   ceilToEven(56.7) // 58   (ceil=57 → +1)
 *
 * @throws Error если `n` не конечное число (NaN, Infinity) — в калькуляторе
 *   negative/non-finite qty невалидно, лучше fail-fast чем тихо считать.
 *   Negative inputs тоже отвергаются.
 */
export function ceilToEven(n: number): number {
  if (!Number.isFinite(n)) {
    throw new Error(`ceilToEven: expected finite number, got ${n}`);
  }
  if (n < 0) {
    throw new Error(`ceilToEven: expected non-negative number, got ${n}`);
  }
  const c = Math.ceil(n);
  return c % 2 === 0 ? c : c + 1;
}
